import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Constants from 'root/constants';
import UI from 'root/ui';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';

var Account_Upgrade_Plan_Select_2022 = View.extend({
    className: 'account-upgrade-plan-select',

    billing_interval: Constants.ANNUALLY,
    plan_type: Constants.PLAN_2022_PREMIUM,

    is_upgrade: false,

    extra_user: {
        [Constants.PLAN_2022_SOLO]   : 0,
        [Constants.PLAN_2022_STARTUP] : 0,
        [Constants.PLAN_2022_COMPANY] : 0,
        [Constants.PLAN_2022_PREMIUM] : 0
    },

    events: {
        'click .billing-cycle-selection > span' : 'selectBillingCycle',
        'click .account-plan'                   : 'selectPlan',
        'click .account-upgrade-continue'       : 'continue',
        'click .account-change-plan'            : 'continue',
        'click .lets-talk'                      : 'letsTalk'
    },

    dom_handlers: {
        selectBillingCycle: function(e) {
            if ($(e.currentTarget).hasClass('active')) {
                return;
            }

            if (this.billing_interval === Constants.MONTHLY) {
                this.billing_interval = Constants.ANNUALLY;

                this.$el.find('.billing-cycle-selection > span:first').removeClass('active');
                this.$el.find('.billing-cycle-selection > span:last').addClass('active');
            } else {
                this.billing_interval = Constants.MONTHLY;

                this.$el.find('.billing-cycle-selection > span:first').addClass('active');
                this.$el.find('.billing-cycle-selection > span:last').removeClass('active');
            }

            this.updatePrice();
        },

        selectPlan: function(e) {
            if (Cache.account.get('appsumo')) {
                return;
            }

            var plan_type = $(e.currentTarget).data('type');
            this.setPlan(plan_type);

            this.updatePrice();

            this.$el.find('.billing-cycle-selection').prop('disabled', false);
        },

        letsTalk: function(e) {
            e.preventDefault();
            UI.openLiveChat();
        },

        continue: function(e) {
            this.trigger('continue', {
                billing_interval : this.billing_interval,
                plan_type        : this.plan_type,
                extra_user       : this.extra_user[this.plan_type]
            });
        }
    },

    updatePrice: function() {
        this.$el.find('.account-plan[data-type="' + Constants.PLAN_2022_SOLO + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2022_SOLO, this.billing_interval));
        this.$el.find('.account-plan[data-type="' + Constants.PLAN_2022_STARTUP + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2022_STARTUP, this.billing_interval));
        this.$el.find('.account-plan[data-type="' + Constants.PLAN_2022_COMPANY + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2022_COMPANY, this.billing_interval));
        this.$el.find('.account-plan[data-type="' + Constants.PLAN_2022_PREMIUM + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2022_PREMIUM, this.billing_interval));

        if (this.billing_interval === Constants.MONTHLY) {
            this.$el.find('.user-price-solo-2022').text('$6');
            this.$el.find('.user-price-startup-2022').text('$6');
            this.$el.find('.user-price-company-2022').text('$6');
            this.$el.find('.user-price-premium-2022').text('$6');
        } else {
            this.$el.find('.user-price-solo-2022').text('$4.50');
            this.$el.find('.user-price-startup-2022').text('$4.50');
            this.$el.find('.user-price-company-2022').text('$4.50');
            this.$el.find('.user-price-premium-2022').text('$4.50');
        }
    },

    setPlan: function(plan_type) {
        this.plan_type = parseInt(plan_type, 10);

        this.$el.find('.account-plan-selected').removeClass('account-plan-selected');
        this.$el.find('.account-plan[data-type="' + plan_type + '"]').addClass('account-plan-selected');

        this.$el.find('.account-upgrade-continue').show();
        this.$el.find('.account-change-plan').show();

        if (Cache.account.get('appsumo')) {
            this.$el.find('.account-upgrade-continue').prop('disabled', true);
        }
    },

    setBillingCycle: function(billing_interval) {
        this.billing_interval = parseInt(billing_interval, 10);
    },

    hasSolo: function() {
        return false;
        //return Cache.account.id <= 38042;
    },

    initialize: function(options) {
        this.is_upgrade = Cache.account.get('is_trial') || Cache.account.get('is_expired') || (Cache.account.get('appsumo') && !Cache.account.get('credit_card_digit'));

        if (this.is_upgrade) {
            if (Cache.account.get('discount_plan_type')) {
                // default to the discounted billing interval
                this.billing_interval = Cache.account.get('discount_plan_type');
            }

            if (Cache.account.get('appsumo')) {
                this.plan_type = Cache.account.get('plan');
            }
        } else {
            // change plan
            this.billing_interval = Cache.account.get('billing_interval');
            this.plan_type        = Cache.account.get('plan');

            // calculate extra users for each plan type
            // so that when changing plan the total user stays the same
            [
                Constants.PLAN_2022_SOLO,
                Constants.PLAN_2022_STARTUP,
                Constants.PLAN_2022_COMPANY,
                Constants.PLAN_2022_PREMIUM
            ].forEach((plan_type) => {
                this.extra_user[plan_type] = Math.max(0, Cache.account.getUserLimit() - Cache.account.getUserLimit(plan_type, false));
            });
        }
    },

    setOptions: function(options) {
        this.billing_interval = options.billing_interval;
        this.plan_type        = options.plan_type;
    },

    choosePlan: function(plan_type) {
        this.$el.find('.account-plan[data-type="' + plan_type + '"]').click();
    },

    continue: function() {
        if (Cache.account.get('appsumo')) {
            this.$el.find('.account-upgrade-continue').trigger('click');
        } else {
            this.$el.find('.account-change-plan').trigger('click');
        }
    },

    render: function() {
        var content = '';

        content += '<div class="account-plan-main">';

        content += '<div class="account-plan-container">' +
                        '<div class="account-plan-billing-cycle-selection">' +
                            '<div class="billing-cycle-selection badge-group-tertiary">' +
                                '<span' + ((this.billing_interval === Constants.MONTHLY  ? ' class="active"' : '')) + '>Monthly</span>' +
                                '<span' + ((this.billing_interval === Constants.ANNUALLY ? ' class="active"' : '')) + '>Yearly<span class="yearly-discount">Save 25%</span></span>' +
                            '</div>' +
                        '</div>' +

                        '<div class="account-plan-grid-container' + (this.hasSolo() ? '' : ' account-plan-grid-container-small') +'">' +

                            // solo
                            (this.hasSolo() ?
                            '<div>' +
                                '<div class="account-plan" data-type="' + Constants.PLAN_2022_SOLO + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title">' + Cache.account.getPlanName(Constants.PLAN_2022_SOLO) + '</span></div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-main">' +
                                            '<div>' +
                                                '<div class="user-num-default">' +
                                                    '<span><span class="user-num">' + (Cache.account.getUserLimit(Constants.PLAN_2022_SOLO, false)) + '</span> Seats</span>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="sub">Add\'l seats <span class="user-price-solo-2022">$4</span> / month</div>' +
                                            '<div class="divider"></div>' +
                                            '<div>' + Cache.account.getProjectLimit(Constants.PLAN_2022_SOLO) + ' Project</div>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<b>Access to:</b>' +
                                            '<ul>' +
                                                '<li>Feedback Widget</li>' +
                                                '<li>Browser Extension</li>' +
                                                '<li>Video Feedback</li>' +
                                                '<li>Team Collaboration</li>' +
                                                '<li>Notifications</li>' +
                                            '</ul>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/legacy-pricing/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' : '') +

                            // startup
                            '<div>' +
                                '<div class="account-plan" data-type="' + Constants.PLAN_2022_STARTUP + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title">' + Cache.account.getPlanName(Constants.PLAN_2022_STARTUP) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-main">' +
                                            '<div>' +
                                                '<div class="user-num-default">' +
                                                    '<span><span class="user-num">' + (Cache.account.getUserLimit(Constants.PLAN_2022_STARTUP, false) ) + '</span> Seats</span>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="sub">Add\'l seats <span class="user-price-startup-2022">$4</span> / month</div>' +
                                            '<div class="divider"></div>' +
                                            (Cache.account.hasProjectLimit() ?
                                            '<div>5 Projects</div>' : '') +
                                            '<div>2,000 session replays / month</div>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<b>' + (this.hasSolo() ? 'Everything in Solo, and' : 'Access to') + ':</b>' +
                                            '<ul>' +
                                                '<li>In-App Surveys <span class="badge-primary-invert badge-small badge-round vbadge-round font-weight-medium">New</span></li>' +
                                                '<li>Feedback Widgets & Templates</li>' +
                                                '<li>Session Replays <span class="badge-primary-invert badge-small badge-round badge-round font-weight-medium">Popular</span></li>' +
                                                '<li>Ideas Portal</li>' +
                                                '<li>Annotated Screenshots</li>' +
                                                '<li>Video Recordings</li>' +
                                                '<li>Survey and Feedback Triggers</li>' +
                                                '<li>Feedback Automation</li>' +
                                                '<li>Integrations inc. Jira, Slack & 16+ more </li>' +
                                                '<li>User Identification & Segments <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                            '</ul>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/legacy-pricing/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                            // company
                            '<div>' +
                                '<div class="account-plan" data-type="' + Constants.PLAN_2022_COMPANY + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title">' + (Cache.account.get('appsumo') ? 'LTD' : Cache.account.getPlanName(Constants.PLAN_2022_COMPANY)) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-main">' +
                                            '<div>' +
                                                '<div class="user-num-default">' +
                                                    '<span><span class="user-num">' + (Cache.account.getUserLimit(Constants.PLAN_2022_COMPANY, false) ) + '</span> Seats</span>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="sub">Add\'l seats <span class="user-price-company-2022">$4</span> / month</div>' +
                                            '<div class="divider"></div>' +
                                            (Cache.account.hasProjectLimit() ?
                                            '<div>15 Projects</div>' : '') +
                                            '<div>20,000 session replays / month</div>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<b>Everything in Startup, and:</b>' +
                                            '<ul>' +
                                                '<li>AI Assist <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                                '<li>Developer Tools</li>' +
                                                '<li>JavaScript SDK</li>' +
                                                '<li>Branding</li>' +
                                                '<li>Email Forwarding <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                                '<li>Advanced Survey Triggers</li>' +
                                                '<li>Conditional Survey Questions <span class="badge-primary-invert badge-small badge-round font-weight-medium">Coming soon</span></li>' +
                                                '<li>Survey Question Randomization</li>' +
                                                '<li>Export Data</li>' +
                                                '<li>Private Ideas Portal</li>' +
                                            '</ul>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/legacy-pricing/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                            // premium
                            '<div>' +
                                '<div class="account-plan" data-type="' + Constants.PLAN_2022_PREMIUM + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title">' + Cache.account.getPlanName(Constants.PLAN_2022_PREMIUM) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-main">' +
                                            (Cache.account.get('appsumo') ?
                                            '<div>Unlimited Seats</div>' +
                                            '<div class="sub">&nbsp;</div>'
                                            :
                                            '<div>' +
                                                '<div class="user-num-default">' +
                                                    '<span><span class="user-num">' + (Cache.account.getUserLimit(Constants.PLAN_2022_PREMIUM, false)) + '</span> Seats</span>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="sub">Add\'l seats <span class="user-price-premium-2022">$6</span> / month</div>') +
                                            '<div class="divider"></div>' +
                                            (Cache.account.hasProjectLimit() ?
                                            '<div>25 Projects</div>' : '') +
                                            '<div>50,000 session replays / month</div>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<b>Everything in Company, and:</b>' +
                                            '<ul>' +
                                                '<li>Webhooks</li>' +
                                                '<li>REST API</li>' +
                                                '<li>Remove Powered By Logo</li>' +
                                                '<li>Invoice Payment</li>' +
                                                '<li>Implementation Support</li>' +
                                                '<li>SOC2 Type 2 Report</li>' +
                                            '</ul>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/legacy-pricing/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +

                        '<div class="text-align-center text-info margin-top-32">All currency is in USD. </div>' +
                    '</div>';

        content += '</div>';

        content += '<div class="account-submit-bar">' +
                        (this.is_upgrade ?
                        '<button class="primary account-upgrade-continue">Continue</button>' :
                        '<button class="primary account-change-plan">Continue</button>') +
                    '</div>';

        this.$el.html(content);

        if (!this.is_upgrade) {
            this.$el.find('.account-plan[data-type="' + Cache.account.get('plan') + '"]').addClass('account-plan-myplan');
        }

        if (Cache.account.get('appsumo')) {
            this.$el.find('.account-plan').addClass('account-plan-disabled');
        }

        this.setPlan(this.plan_type);
        this.updatePrice();

        return this;
    }
});

export default Account_Upgrade_Plan_Select_2022;
